.wrapper {
    position: sticky;
    top: 0;
    z-index: 101;
}

.banner {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 16px;
    padding: 8px 16px;
    background-color: #0d74ce;
    color: #ffffff;
    font-family: 'Outfit', 'Helvetica Neue', Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}

.label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    text-transform: uppercase;
    white-space: nowrap;
}

.toggle {
    display: none;
    align-items: center;
    gap: 8px;
    padding: 0;
    border: none;
    background: none;
    color: inherit;
    font: inherit;
    cursor: pointer;
}

.details {
    display: contents;
}

.message {
    margin: 0;
    text-align: center;
}

.link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 16px;
    border-radius: 4px;
    background-color: #ffffff;
    color: #21201c;
    text-decoration: none;
    white-space: nowrap;
}

.link:hover {
    background-color: #f1f0ef;
}

.link:focus-visible,
.toggle:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
}

@media (max-width: 767.98px) {
    .banner {
        grid-template-columns: 1fr;
        gap: 8px;
    }

    .desktopLabel {
        display: none;
    }

    .toggle {
        display: flex;
        justify-self: center;
    }

    .toggle[aria-expanded='true'] .caret {
        transform: rotate(180deg);
    }

    .details {
        display: none;
        flex-direction: column;
        gap: 8px;
        padding-bottom: 4px;
    }

    .expanded {
        display: flex;
    }

    .message {
        text-align: left;
    }
}
